// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
  BUTTON: '[data-is="ShowMorePhotos"]',
};

class ShowMorePhotos extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.button = document.querySelector(fragments.BUTTON);
  }

  didMount() {
    this.button.addEventListener('click', this.handleClick);
  }

  willUnMount() {
    this.button.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const galleryItemHide = Array.from(document.getElementsByClassName('gallery__item--hide'));

    this.element.nextElementSibling.removeAttribute('tabindex');
    this.element.parentNode.removeChild(this.element);
    for (let i = 0; i < galleryItemHide.length; i += 1) {
      galleryItemHide[i].classList.remove('gallery__item--hide');
    }
  }
}

export default ShowMorePhotos;



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/ShowMorePhotos.js